<template>
  <div class="user_page">
    <h3 class="title-page">{{ $t("team") }}</h3>
    <div>
      <div class="admin_container">
        <div class="division_main">
          <team-index-filter
            v-model="isShowFilter"
            :filter="options"
            @change="getItemsWthLoading"
          />
          <div class="text-right mb-3">
            <v-btn
              color="primary"
              @click="$router.push({ name: 'team-create' })"
              >{{ $t("create") }}</v-btn
            >
          </div>
          <table-with-children
            :headers="headers"
            :items="items"
            :options.sync="options"
            class="table-wth-children table_cover"
            fixed-header
            hide-default-footer
            @update:sort="getItemsWthLoading"
          >
            <template #item.price="{ item: { price } }">{{
              price | numberParse
            }}</template>
            <template #item.productAttrs="{ item: { productAttrs } }">
              <span v-if="productAttrs">{{ productAttrs.join(" & ") }}</span>
            </template>
            <template #item.action="{ index, item }">
              <v-tooltip color="#fff" left nudge-right="10" nudge-top="35">
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    class="new_style"
                    @click="
                      $router.push({
                        name: 'team-edit',
                        params: { id: item.id },
                      })
                    "
                  >
                    <vue-icon icon="newPencilIcon" />
                  </v-btn>
                </template>
                <span>{{ $t("edit") }}</span>
              </v-tooltip>
            </template>
          </table-with-children>
        </div>
        <vue-pagination
          @update:limit="
            (limit) => {
              options.limit = limit;
              options.page = 1;
            }
          "
          v-model="options.page"
          :length="lastPage"
          go-to
          :limit="options.limit"
        />
        <SplitTest />
      </div>
    </div>
  </div>
</template>

<script>
import tableWithChildren from "@/components/table-with-children/tableWithChildren";
import {
  getQueryByKey,
  makerPagination,
  shallowEqual,
} from "@/utils/pureFunctions";
import { numberOnly } from "@/utils/inputRegExps";
import TeamIndexFilter from "@/components/team/TeamIndexFilter";
import VuePagination from "@/components/ui/vue-pagination/VuePagination";
import SplitTest from "@/components/attribute-separation/AttributeSeparation";

export default {
  data() {
    return {
      isShowFilter: false,
      options: {
        sortBy: "id",
        sortDesc: true,
        page: 1,
        limit: 10,
      },
      items: [],
      lastPage: 0,
    };
  },
  watch: {
    options: {
      handler(val) {
        const query = { ...this.$route.query };
        if (query.page) query.page = +query.page;
        if (!shallowEqual(query, val)) {
          this.$router.replace({ query: val });
        }
        this.getItemsWthLoading();
      },
      deep: true,
      immediate: false,
    },
  },
  computed: {
    numberOnly: () => numberOnly,
    headers() {
      return [
        { text: this.$t("name"), value: "name" },
        { text: this.$t("team"), value: "teamLeaderName" },
        { text: this.$t("action"), value: "action" },
      ];
    },
  },
  methods: {
    async getItemsWthLoading() {
      this.showLoading();
      await this.getItems();
      this.clearLoading();
    },
    async getItems() {
      try {
        const params = { ...this.options };
        --params.page;
        const {
          data: { data, total },
        } = await this.$http.get("teams", { params });
        this.items = data;
        this.lastPage = makerPagination({
          limit: params.limit,
          total,
        }).lastPage;
      } catch (e) {
        this.setResponseError({ error: e });
      }
    },
  },
  created() {
    const { query } = this.$route;
    const options = getQueryByKey(this.options, query);
    if (typeof options.page === "string") options.page = +options.page;
    this.options = options;
  },
  components: {
    SplitTest,
    VuePagination,
    TeamIndexFilter,
    tableWithChildren,
  },
};
</script>
